import React, { useState } from "react";
import '../styles/LabResultItem.css';
import { useAuth } from "../context/AuthContext";
import { Api } from "../api/Api";
import { showToast } from "../helpers/UIHelper";
import {  Spin } from "antd";

const LabResultItem = ({ item }) => {
    const Auth = useAuth();
    const [isViewLoading, setIsViewLoading] = useState(false);
    const [isDownloadLoading, setIsDownloadLoading] = useState(false);
    const formatResponseDate = (date) => {
        var newDate = date.split(" ");
        newDate = newDate[0].split("-")
        return `${newDate[2]}-${newDate[1]}-${newDate[0]}`
    }
    const getUrl = () => {
        //const patientId = Auth.getUser().data.patients[0].patientId ? Auth.getUser().data.patients[0].patientId : null;
        const patientId = item.patientId;
        const url = item.resulttypeId === '640' ?
            "?_reportFormat=pdf&ReportName=TemplateReportServiceCenter.rptdesign&__id=parameterPage&__masterpage=true" +
                "&orderIds=*"+item.laborderId+"&patientId="+ (patientId ? patientId : '') +"&visitid="+item.visitId+"&sampleId=*"+item.sampleid+"&resultId="+item.labresultid+"&generatedBy=2&provisionallyCertified=false&intraBranchId=2" :
            "?_reportFormat=pdf&ReportFileName=selectedLabReportByOrder.rptdesign&ReportName=selectedLabReportByOrder.rptdesign&__id=parameterPage&__masterpage=true&" +
            "orderIds=*" + item.laborderId + "&patientId=" + (patientId ? patientId : '')  + "&generatedBy=2&invoiceId=*" + item.invoiceId + "&onlyMicrobiology=false&provisionallyCertified=false&intraBranchId=2&labQrCodePath=&labPatInfoQrCodePath=";
        return url;
    }

    const viewReport = () => {
        setIsViewLoading(true);
        const url = getUrl();
        Api.getReport(url).then((resp) => {
            if (resp.status===200) {
                const blob = new Blob([resp.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);
                //setPdfUrl(url);
            }
        }).catch((e) => {
            showToast('error', 'Error occured');
            console.log(e);
        }).finally(() => { setIsViewLoading(false);})
    }

    const download = () => {
        debugger;
        setIsDownloadLoading(true);
        const url = getUrl();
        Api.getReport(url).then((resp) => {
            if (resp.status===200) {
                const blob = new Blob([resp.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'report.pdf'; 
                document.body.appendChild(link);
                link.click(); 
                document.body.removeChild(link);
            }
        }).catch((e) => {
            showToast('error', 'Error occured');
            console.log(e);
        }).finally(() => { setIsDownloadLoading(false); })
    }
    return (
        <>
        <div className="result-item">
            <div className="lab-name">
                {item.service_name}
            </div>
            <div className="lab-date">
                {'Ordered On '+formatResponseDate(item.ordereddate)+' by '+item.orderedCons}
            </div>
            <div className="actions-area">
                {isViewLoading ? <div><Spin/></div> : <i className="las la-eye" onClick={() => { viewReport() }} />}
                {isDownloadLoading ? <div><Spin/></div> : <i className="las la-download" onClick={() => { download(); }} />}
            </div>    
        </div>
        </>
    )
}
export default LabResultItem;